// react
import { useEffect, useState } from 'react';
import * as React from "react";
import * as ReactDOM from "react-dom";

// kendo
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartTitle,
  ChartLegend,
  ChartTooltip,
  ChartSeriesItemTooltip
} from "@progress/kendo-react-charts";

// css
import styles from './elderLog.module.css';

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numFormat, roundNum } from "../../../com/dataUtil";
import { labelColor } from "./labelColor";

// 그래프
const ElderLogChart = ({ search, dataSource, elderInfo }) => {

  const gathDtm = dataSource.chartData.gathDtm;
  const movement = dataSource.chartData.movementData;
  const movementPure = dataSource.chartData.movementPureData;
  const movementTotal = dataSource.chartData.movementTotalData;
  const velocity = dataSource.chartData.velocityData;
  const velocityTotal = dataSource.chartData.velocityTotalData;
  const temperature = dataSource.chartData.temperatureData;
  const humidity = dataSource.chartData.humidityData;
  const co2 = dataSource.chartData.co2Data;
  const tvoc = dataSource.chartData.tvocData;
  const light = dataSource.chartData.lightData;
  const meainStatCode = dataSource.chartData.meainStatCodeData;
  const meainStatTerm = dataSource.chartData.meainStatTermData;

  const dataStatSctCodeVal = dataSource.chartData.dataStatSctCodeValData;
  const [plotBands, setPlotBands] = useState([]);
  
  useEffect(() => {
    const plotBands = [];
    if (meainStatCode) {
      meainStatCode.forEach((item, index) => {
        const from = index - 0.5;
        const to = index + 0.5;
        const color = labelColor[item];
        plotBands.push({ from, to, color });
      });
      setPlotBands(plotBands);
    }
  }, [dataSource.chartData]);

  const chart = {
    chart: { zoomType: "xy", backgroundColor: "#FFFFFF" },
    noData: {
      style: {
        color: "#FFFFFF",
        fontSize: "14px",
      },
    },
    title: {
      text: null,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    xAxis: {
      plotBands: plotBands,
      categories: gathDtm,
      labels: {
        rotation: 15, 
        // step: 10,
        formatter: function () {
          const data = new Date(this.value);
          const yy = data.getFullYear() + "";
          const month = data.getMonth() + 1 < 10 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
          const day = data.getDate() < 10 ? "0" + data.getDate() : data.getDate();
          const hour = data.getHours() < 10 ? "0" + data.getHours() : data.getHours();
          const minutes = data.getMinutes() < 10 ? "0" + data.getMinutes() : data.getMinutes();
          return hour + ":" + minutes + "";
        },
      },
    },
    yAxis: [
      {
        showEmpty: false,
        labels: {
          formatter: function() {
            return Highcharts.numberFormat(this.value, 0, '.', ',') + '°C';
          },
          style: {
            color: "#cf4f3c",
          },
        },
        title: {
          text: "온도",
          style: {
            color: "#cf4f3c",
          },
          rotation: 0,
          y: -20,
          x: 0,
          offset: 15,
          align: "high",
        },
        opposite: true,
      },
      {
        showEmpty: false,
        labels: {
          formatter: function() {
            return Highcharts.numberFormat(this.value, 0, '.', ',') + '%';
          },
          style: {
            color: "#3c85cf",
          },
        },
        title: {
          text: "습도",
          style: {
            color: "#3c85cf",
          },
          rotation: 0,
          y: -20,
          // x: 13,
          offset: 15,
          align: "high",
        },
        opposite: true,
      },
      {
        showEmpty: false,
        labels: {
          formatter: function() {
            return Highcharts.numberFormat(this.value, 0, '.', ',') + 'ppm';
          },
          style: {
            color: "#347835",
          },
        },
        title: {
          text: "CO2",
          style: {
            color: "#347835",
          },
          rotation: 0,
          y: -20,
          // x: 7,
          offset: 30,
          align: "high",
        },
        opposite: true,
      },
      {
        showEmpty: false,
        labels: {
          formatter: function() {
            return Highcharts.numberFormat(this.value, 0, '.', ',') + 'ppm';
          },
          style: {
            color: "#84c93e",
          },
        },
        title: {
          text: "TVOC",
          style: {
            color: "#84c93e",
          },
          rotation: 0,
          y: -20,
          x: -5,
          offset: 25,
          align: "high",
        },
        min: 0,
        opposite: true,
      },
      {
        showEmpty: false,
        labels: {
          formatter: function() {
            return Highcharts.numberFormat(this.value, 0, '.', ',') + 'Lx';
          },
          style: {
            color: "#cf9c3c",
          },
        },
        title: {
          text: "조도",
          style: {
            color: "#cf9c3c",
          },
          rotation: 0,
          y: -20,
          x: 10,
          offset: 25,
          align: "high",
        },
        opposite: false,
      },
      {
        showEmpty: false,
        labels: {
          formatter: function() {
            return Highcharts.numberFormat(this.value, 0, '.', ',');
          },
          style: {
            color: "#9a5fc2",
          },
        },
        title: {
          text: "속도",
          style: {
            color: "#9a5fc2",
          },
          // ,
          rotation: 0,
          y: -20,
          x: 0,
          offset: 15,
          align: "high",
        },
        opposite: false,
      },
      {
        showEmpty: false,
        labels: {
          formatter: function() {
            return Highcharts.numberFormat(this.value, 0, '.', ',');
          },
          style: {
            color: "#3d3c3b",
          },
        },
        title: {
          text: "움직임",
          style: {
            color: "#3d3c3b",
          },
          // ,
          rotation: 0,
          y: -20,
          x: -5,
          offset: 0,
          align: "high",
        },
        opposite: false,
      },
    ],
    tooltip: {
      shared: true,
      formatter: function () {
        let s = "<b>" + this.x + "</b>";
        let state;
        meainStatTerm.find((e) => {
          if(this.x === e.gathDtm) {
            state = e.meainStatTerm;
          }
        })
        this.points.forEach((item, index) => {
          if (index <= 10) {
            s +=
            "<br/>" +
            '<span style="color:' +
            this.points[index].point.color +
            '">\u25CF</span> ' +
            this.points[index].series.name +
            ": " +
            numFormat(roundNum(this.points[index].y, 3)) +
            " ";
          }
        });
        if(state) {
          s += 
          "<br/>" +
          "<br/>" +
          '<span style="color: #d63865;  font-weight: bold;">' + state + '</span>'
        }
        return s;
      },
    },
    plotOptions: {
      spline: {
          lineWidth: 2,
          marker: {
              enabled: false
          },
      },
      areaspline: {
        lineWidth: 2,
          marker: {
              enabled: false
          },
      }
    },
    legend: {
      align: "center",
      verticalAlign: "top",
      backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || "#FFFFFF",
    },
    series: [
      {
        yAxis: 0,
        visible: false,
        name: "온도",
        type: "spline",
        data: temperature,
        color: "#cf4f3c",
        shadow: true,
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, "#cf4f3c"],
            [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get("rgba")],
          ],
        },
      },
      {
        yAxis: 1,
        visible: false,
        name: "습도",
        type: "spline",
        data: humidity,
        color: "#3c85cf",
        shadow: true,
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, "#3c85cf"],
            [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get("rgba")],
          ],
        },
      },
      {
        yAxis: 2,
        visible: false,
        name: "CO2",
        type: "spline",
        data: co2,
        color: "#347835",
        shadow: true,
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, "#347835"],
            [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get("rgba")],
          ],
        },
      },
      {
        yAxis: 3,
        visible: false,
        name: "TVOC",
        type: "spline",
        data: tvoc,
        color: "#84c93e",
        shadow: true,
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, "#84c93e"],
            [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get("rgba")],
          ],
        },
      },
      {
        yAxis: 4,
        name: "조도",
        type: "spline",
        data: light,
        color: "#cf9c3c",
        shadow: true,
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, "#cf9c3c"],
            [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get("rgba")],
          ],
        },
      },
      {
        yAxis: 5,
        name: "속도",
        type: "areaspline",
        data: velocityTotal,
        color: "#9a5fc2",
        shadow: true,
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 2,
          },
          stops: [
            [0, "#9a5fc2"],
            [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get("rgba")],
          ],
        },
      },
      {
        yAxis: 6,
        name: "움직임",
        type: "areaspline",
        data: movement,
        color: "#3d3c3b",
        shadow: true,
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 2,
          },
          stops: [
            [0, "#3d3c3b"],
            [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get("rgba")],
          ],
        },
      },
    ],
  };
  Highcharts.setOptions({
    lang: {
      resetZoom: "줌 초기화",
      noData: "데이터가 없습니다.",
    },
    noData: {
      style: {
        fontWeight: "bold",
        fontSize: "15px",
        color: "#303030",
      },
    },
  });

  return (
    <div className={styles.elderLogChart}>
      <HighchartsReact highcharts={Highcharts} options={chart} />
    </div>
  );
};

export default ElderLogChart;